import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectReviewService {

  constructor(private http: HttpClient) { }

  private httpOptions = {
    withCredentials: true
  };

  /**
   * GET projects for a tax year.
   * Original: ProjectReviewFactory.getProjectsByTaxYear(taxYear)
   * URL: /projectReview/getProjectsByTaxyear?taxYear={taxYear}
   */
  getProjectsByTaxYear(customApiUrl: string, taxYear: string): Observable<any> {
    const url = `${customApiUrl}/projectReview/getProjectsByTaxyear?taxYear=${taxYear}`;
    return this.http.get<any>(url, this.httpOptions).pipe(
      map((response: any) => response.ProjectsByTaxyear || [])
    );
  }

  /**
   * GET steps for a project.
   * Original: ProjectReviewFactory.getProjectSteps(project_id, filterParams)
   */
  getProjectSteps(customApiUrl: string, projectId: string, filterParams: any): Observable<any> {
    const url = `${customApiUrl}/projectReview/getProjectSteps?project_id=${projectId}&tax_year=${filterParams.tax_year}&scenario=${filterParams.scenario}&filingKey=${filterParams.filing_key}&parent_me_string=${filterParams.parent_me_string}`;
    return this.http.get<any>(url, this.httpOptions).pipe(
      map((response: any) => response.projectSteps || [])
    );
  }

  /**
   * GET transaction data for a project.
   * Original: ProjectReviewFactory.getTransactionData(project_id, filterParams)
   */
  getTransactionData(customApiUrl: string, projectId: string, filterParams: any): Observable<any> {
    const url = `${customApiUrl}/projectReview/getTransactionData?project_id=${projectId}&tax_year=${filterParams.tax_year}&scenario=${filterParams.scenario}&filingKey=${filterParams.filing_key}&parent_me_string=${filterParams.parent_me_string}`;
    return this.http.get<any>(url, this.httpOptions).pipe(
      map((response: any) => response.transactionData || [])
    );
  }

  /**
   * GET transaction data for a specific project step (child rows).
   * Original: AJAX call in DataTables configuration
   * URL: /projectReview/getTransactionDataForProjectStep?project_id=...&project_step_id=...
   */
  getTransactionDataForProjectStep(customApiUrl: string, projectId: string, projectStepId: string, filterParams: any): Observable<any> {
    const url = `${customApiUrl}/projectReview/getTransactionDataForProjectStep?project_id=${projectId}&project_step_id=${projectStepId}&tax_year=${filterParams.tax_year}&scenario=${filterParams.scenario}&filingKey=${filterParams.filing_key}&parent_me_string=${filterParams.parent_me_string}`;
    return this.http.get<any>(url, this.httpOptions).pipe(
      map((response: any) => response.transactionData || [])
    );
  }
}
